<template>
    <div>
        <form ref="formRicerca" autocomplete="off" method="POST" class="mainForm" action="/search">
            <input autocomplete="false" type="hidden" class="hidden-field" :value="currentsearch ? currentsearch.categoria : null" name="categoria" required />
            <input autocomplete="false" ref="geojson" type="hidden" name="geojson" id="geojson_desktop" />
            <input type="hidden" name="_token" id="csrf-token" :value="csrf" />
            <input type="hidden" name="sort_order" :value="currentsearch ? currentsearch.order : ''">
            <input type="hidden" name="sort_direction" :value="currentsearch ? currentsearch.direction : ''">
            <div class="row">
                <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12" v-if="show_categorie_select">
                    <div class="form-group">
                        <category-select 
                            :label="show_label ? 'Categoria' : ''" 
                            labelcolor="#FFFFFF" 
                            :primarycolor="colors.primary" 
                            style="flex: 1 1 auto;" 
                            :options="formdata.categorie" 
                            name="categoria" 
                            trackby="id" 
                            :required="true" 
                            :allowEmpty="false" 
                            @onChange="$emit('get-tipologie', $event)" 
                            :currentvalue="selectedValue.categoria" 
                            selectname="categoria" 
                            placeholder="Seleziona...">
                        </category-select>
                    </div>
                </div>

                <div :class="show_categorie_select ? 'col-lg-2 col-md-6 col-sm-12 col-xs-12' :
              'col-lg-2 col-md-12 col-sm-12 col-xs-12'">
                    <div class="form-group">
                        <category-select 
                            :label="show_label ? 'Contratto' : ''" 
                            :labelcolor="colors.secondary" 
                            :primarycolor="colors.primary" 
                            style="flex: 1 1 auto;" 
                            :options="formdata.contratti" 
                            name="contratto" 
                            trackby="id" 
                            :required="true" 
                            :allowEmpty="false" 
                            @onChange="$emit('update-prezzi', $event)" 
                            :currentvalue="selectedValue.contratto" 
                            selectname="contratto" 
                            placeholder="Seleziona...">
                        </category-select>
                    </div>
                </div>

                <div :class="show_categorie_select ? 'col-lg-6 col-md-12 col-sm-12 col-xs-12' :
      'col-lg-8 col-md-12 col-sm-12 col-xs-12'">

                    <div :class="show_label ? 'form-group' :'input-group'">
                        <zone-select 
                            :label="show_label ? 'Zone' : ''" 
                            :labelcolor="colors.secondary" 
                            :primarycolor="colors.primary" 
                            name="zone" 
                            style="flex: 1 1 auto;" 
                            selectname="zone" 
                            trackby="id" 
                            :disabled="zoneIsDisabled()" 
                            @clear-value="clearZone" 
                            :currentvalue="selectedValue.zone" 
                            :options="formdata.zone" 
                            :required="!$root.mapselected ? true : false" 
                            placeholder="Seleziona...">
                        </zone-select>

                        <div class="input-group-append" v-if="show_cerca_su_mappa">
                            <button v-if="$root.mapselected" class="mapSearchBtn mapSearchBtn-advanced btn-brr btn-secondary-sm selected" @click="$emit('removeselection')" type="button">Rimuovi Selezione Mappa</button>
                            <button v-if="!$root.mapselected" class="mapSearchBtn mapSearchBtn-advanced btn-brr btn-secondary-sm" @click="$emit('showmap')" type="button">Disegna area di ricerca</button>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row">
                <div :class="show_cerca_subito ? 'col-lg-4 col-md-12 col-sm-12 col-xs-12' :
      'col-lg-4 col-md-12 col-sm-12 col-xs-12'">
                    <div class="form-group" id="tipologie">
                        <tipologia-select 
                            :label="show_label ? 'Tipologie' : ''" 
                            :labelcolor="colors.secondary" 
                            :primarycolor="colors.primary" 
                            style="flex: 1 1 auto;" 
                            :options="formdata.tipologie" 
                            name="tipologie" 
                            trackby="id" 
                            :closeonselect="false" 
                            :currentvalue="selectedValue.tipologie" 
                            :multiple="true" 
                            selectname="tipologie" 
                            placeholder="Seleziona..." 
                            selection_name="tipologie" 
                            :required="true" 
                            @onChange="$emit('cambio-tipologie', $event)">
                        </tipologia-select>
                    </div>
                </div>

                <div :class="show_cerca_subito ? 'col-lg-4 col-md-12 col-sm-12 col-xs-12' :
                   'col-lg-5 col-md-12 col-sm-12 col-xs-12'">
                    <vue-select-price 
                        :labelcolor="colors.secondary" 
                        :primarycolor="colors.primary" 
                        :prezzi="formdata.prezzi" 
                        :nolabel="!show_label" 
                        :currentsearch="currentsearch ? currentsearch : null">
                    </vue-select-price>
                </div>

                <div :class="show_cerca_subito ? 'col-lg-1 col-md-12 col-sm-12 col-xs-12' :
          'col-lg-2 col-md-12 col-sm-12 col-xs-12'" :style="show_label ? 'display: flex; flex-direction: column; justify-content: center;' : ''">
                    <div class="centerone">
                        <a class="centerone" data-toggle="collapse" data-target="#options-content">
                            ALTRI FILTRI
                        </a>
                    </div>
                </div>
                <div v-if="show_cerca_subito" class="col-lg-3 col-md-12 col-sm-12 col-xs-12 align-middle" :style="show_label ? 'display: flex; flex-direction: column; justify-content: center;' : ''">
                    <div class="form-group mb-0">
                        <button class="search-button">
                          <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                          <template v-else>Cerca Subito</template>
                        </button>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div id="options-content" class="collapse pb-3">
                        <ul class="strong">
                            <strong class="color-smart">*Ulteriori caratteristiche (indica solo quello che per te è fondamentale)</strong>
                        </ul>
                        <advanced-filters v-if="formdata.filtriAvanzati" columnclass="col-lg-3 col-md-3 col-sm-6" :labelcolor="colors.secondary" :primarycolor="colors.primary" :filtri="formdata.filtriAvanzati" :currentvalue="currentsearch ? currentsearch : null" :id_text_prepend="id_text_prepend" />
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
    export default {
        name: 'CampiFormRicerca',
        props: {
            colors: {},
            currentsearch: null,
            formdata: {},
            selectedValue: {},
            homepagedata: {},
            removeSelection: {},
            show_categorie_select: {
                type: Boolean,
                default: false
            },
            show_cerca_subito: {
                type: Boolean,
                default: true
            },
            show_cerca_su_mappa: {
                type: Boolean,
                default: true
            },
            show_label: {
                type: Boolean,
                default: false
            },
            id_text_prepend: {
                type: String,
                default: ''
            }
        },
  
        mounted () {
            this.$refs.formRicerca.addEventListener('submit', () => {
                this.loading = this.$refs.formRicerca.checkValidity();
            })

            this.zoneOptions = (this.currentsearch.frazioniDropdown && this.currentsearch.frazioniDropdown.length > 0) ? this.currentsearch.frazioniDropdown : this.homepagedata.zone;
        },
        data() {
            return {
                zoneOptions: [],
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                loading: false,
            }
        },
        methods: {
            clearZone() {
                this.zoneOptions = this.homepagedata.zone;
            },
            zoneIsDisabled() {
                return this.$root.mapselected ? true : false;
            },
        }
    }
</script>
<style lang="css">
    .selected {
        background-color: var(--primary) !important;
        color: white;
    }
</style>